export default function Index() {
  return (
    <div>test2</div>
  );
}